import { render, staticRenderFns } from "./SwiperNews.vue?vue&type=template&id=5844d760&scoped=true&"
import script from "./SwiperNews.vue?vue&type=script&lang=js&"
export * from "./SwiperNews.vue?vue&type=script&lang=js&"
import style0 from "./SwiperNews.vue?vue&type=style&index=0&id=5844d760&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5844d760",
  null
  
)

export default component.exports